import { Component, ElementRef } from '@angular/core';
import 'moment/locale/id';
import { RequestFakturRestService } from '../request-faktur-rest.service';
import Swal from 'sweetalert2';
import { APP_CONST } from '../../../app.const';
import { RequestFakturListComponent } from '../list/request-faktur-list.component';

@Component({
  selector: 'app-add-modal',
  templateUrl: 'add-modal.component.html',
  styleUrls: ['../request-faktur-module.scss']
})
export class AddModalComponent {
  isModalOpen: boolean = false;
  customerData: any = null; // To store fetched customer data
  selectedCustomer: any = null;
  uploadEndpoint = APP_CONST.API_FILE;
  customerType: string = 'perorangan';
  uploadResetTrigger = Date.now(); // default

  formDataPerorangan = {
    jenisPengajuan: 'perorangan',
    spkNumber: '',
    noRangka: '',
    noDinamo: '',
    noKtp: '',
    noKk: '',
    namaPelanggan: '',
    fotoKtp: '',
    fotoKk: ''
  };

  formDataPerusahaan = {
    jenisPengajuan: 'perusahaan',
    spkNumber: '',
    noRangka: '',
    noDinamo: '',
    npwp: '',
    fotoNpwp: '',
    nip: '',
    fotoNip: '',
    dokumenDomisili: ''
  };

  onMotorcycleNumberChange(index: number) {
    this.selectedCustomer = this.customerData[index];
  }

  constructor(
    private _RequestFakturRest: RequestFakturRestService,

    public _requestFakturListComponent: RequestFakturListComponent
  ) {}

  resetFormData() {
    this.formDataPerorangan = {
      jenisPengajuan: 'perorangan',
      spkNumber: '',
      noRangka: '',
      noDinamo: '',
      noKtp: '',
      noKk: '',
      namaPelanggan: '',
      fotoKtp: '',
      fotoKk: ''
    };

    this.formDataPerusahaan = {
      jenisPengajuan: 'perusahaan',
      spkNumber: '',
      noRangka: '',
      noDinamo: '',
      npwp: '',
      fotoNpwp: '',
      nip: '',
      fotoNip: '',
      dokumenDomisili: ''
    };
  }

  openModal() {
    this.isModalOpen = true;
    this.customerData = null; // Reset customer data when modal is opened
    this.resetFormData();
  }

  closeModal() {
    this.uploadResetTrigger = Date.now(); // trigger rese
    this.isModalOpen = false;
    this.resetFormData();
  }

  onSpkInputChange() {
    if (this.customerType === 'perorangan') {
      if (this.formDataPerorangan.spkNumber) {
        this.fetchCustomerData(); // Trigger fetch when input reaches 16 characters
      }
    } else {
      if (this.formDataPerusahaan.spkNumber) {
        this.fetchCustomerData(); // Trigger fetch when input reaches 16 characters
      }
    }
  }

  fetchCustomerData() {
    if (this.customerType === 'perorangan') {
      if (!this.formDataPerorangan.spkNumber) {
        Swal.fire('Error', 'Please enter a valid SPK Number.', 'error');
        return;
      }
    } else {
      if (!this.formDataPerusahaan.spkNumber) {
        Swal.fire('Error', 'Please enter a valid SPK Number.', 'error');
        return;
      }
    }

    let payload = {};
    if (this.customerType === 'perorangan') {
      payload = { spkNumber: this.formDataPerorangan.spkNumber };
    } else {
      payload = { spkNumber: this.formDataPerusahaan.spkNumber };
    }

    this._RequestFakturRest.getChassisBySpkNumber(payload).subscribe({
      next: response => {
        this.customerData = response;
        console.log('Customer Data:', this.customerData);
      },
      error: err => {
        const errorMessage = err.response.data.message;

        Swal.fire('Error', errorMessage, 'error');
      }
    });
  }

  onImageFinishUploaded(image: any, inputName: string) {
    if (image?.storageFileName) {
      if (this.customerType === 'perorangan') {
        // Use type assertion to tell TypeScript this is allowed
        (this.formDataPerorangan as any)[inputName] = image.storageFileName;
      } else {
        (this.formDataPerusahaan as any)[inputName] = image.storageFileName;
      }
    } else {
      Swal.fire('Error', 'Terjadi kesalahan saat mengunggah file. Silakan coba lagi.', 'error');
    }
  }

  // Method to handle the submit action
  onSubmit(form) {
    if (form.valid) {
      const dataToSubmit =
        this.customerType === 'perorangan' ? { ...this.formDataPerorangan } : { ...this.formDataPerusahaan };

      console.log('Data to submit:', dataToSubmit);

      this._RequestFakturRest.create(dataToSubmit).subscribe({
        next: response => {
          Swal.fire('Success', 'Request faktur success!', 'success');
          this._requestFakturListComponent.callHookDirectly('init');
          this.closeModal();
        },
        error: err => {
          const errorMessage = err?.response?.data?.message || 'Unknown error';
          Swal.fire('Error', `Failed to request faktur: ${errorMessage}`, 'error');
        }
      });
    } else {
      const invalidFields: string[] = [];

      const optionalFields = this.customerType === 'perusahaan' ? ['npwp', 'fotoNpwp', 'hiddenFotoNpwp'] : [];

      Object.keys(form.controls).forEach(field => {
        const control = form.controls[field];
        if (control.invalid && !optionalFields.includes(field)) {
          invalidFields.push(field);
          control.markAsTouched(); // biar error di form juga muncul
        }
      });

      const formattedFields = invalidFields
        .map(field => field.replace(/hidden/gi, '')) // remove 'hidden'
        .map(field => field.replace(/nip/gi, ' nib')) // replace 'nip' with 'nib'
        .map(field => field.replace(/([A-Z])/g, ' $1')) // camelCase to space
        .map(field => field.charAt(0).toUpperCase() + field.slice(1)); // capitalize

      Swal.fire(
        'Oops!',
        `Please fill in the following required fields:<br><ul>${formattedFields
          .map(f => `<li>${f}</li>`)
          .join('')}</ul>`,
        'error'
      );
    }
  }
}
